
import {Vue, Component, Prop} from 'vue-property-decorator';
import baseUrl, {imageUrl} from '@/constants';
import {compressionFile, rotateBase64Img} from "@/common/imageCompress";
import {uploadApi} from "@/api/upload";

@Component({})
export default class imgUploadOneOnline extends Vue {
  @Prop() private title!: string;
  @Prop() private imgTitle!: string;
  @Prop() private show!: string; // edit show

  baseUrl = baseUrl
  headers = {Authorization: ""}
  pageFile = '' // 上传后的图片地址
  fileList = [] as any;
  edg = 0; // 旋转角度
  dialogImageUrl = ''
  dialogVisible = false
  hideUpload = false // 是否隐藏上传框
  accepts = ['JPEG','JPG', 'PNG']

  // 选择文件
  handleChange(file: any, fileLists: any) {
    this.hideUpload = true;
  }

  handleAvatarSuccessCheck(res: any, file: any) {
    if (res.result === 0) {
      const rData = res.data;
      this.fileList = [{name: this.title, url: imageUrl+rData}];
      this.pageFile = rData;
      this.hideUpload = true;
    }
  }

  beforeAvatarUploadCheck(file: any) {
    const isLt2M = file.size / 1024 / 1024 < 2;
    const lastIndex = file.name.lastIndexOf(".");
    if(lastIndex === -1){
      this.$message.error('此文件格式不存在');
      return false;
    }
    //后缀
    const suffix = file.name.substring(lastIndex + 1 , file.name.length);
    if(this.accepts.indexOf(suffix.toUpperCase()) > -1){
      return new Promise((resolve) => {
        // 小于2M 不压缩
        if (isLt2M) {
          resolve(compressionFile(file, this.edg, 'image/jpeg', 1))
        }
        resolve(compressionFile(file, this.edg, 'image/jpeg', 0.5))
      });
    }else{
      this.$message.error('上传只能是 ' + this.accepts.join(" 或 ") +' 格式!');
      return false;
    }
  }

  handlePictureCardPreview(file: any) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }

  imgV = Math.random();
  rotate(file: any, edg: number) {
    // 审核转图片走接口
    uploadApi.rotateImage({path: file.url.replace(imageUrl,""), edg: edg}).then(r=>{
      if(r.data.result === 0){
        this.imgV = Math.random();
      }
    })
  }

  handleRemoveCheck() {
    this.fileList = [];
    this.pageFile = '';
    this.hideUpload = false;
  }

  getData() {
    return this.pageFile;
  }

  setData(row: string) {
    this.pageFile = row;
    this.fileList = [{name: this.title, url: imageUrl+row}];
    this.hideUpload = true;
  }

  submitUpload() {
    (this.$refs.upload as any).submit();
  }
}
